module.exports = __webpack_public_path__ + "img/hero-j-half.781b7aef.jpg";